export const TRACK_SOURCE = 'search'

export const PAGE_TYPE = 'search'
